import { isNonEmptyString, truncateText } from '@sortlist-frontend/utils';

import { Page } from '_types/public-api';

const DESCRIPTION_MAX_LENGTH = 155;

const getExcerptDescription = (excerpt: string | undefined) =>
  isNonEmptyString(excerpt) ? truncateText(excerpt, DESCRIPTION_MAX_LENGTH) : undefined;

export const getPageSeoMeta = (page: Page) => {
  const { metadata, title } = page.data.attributes;
  const titleTag = metadata?.title_tag;
  const metaDescription = metadata?.metadescription;
  const hasOwnTitle = isNonEmptyString(titleTag);
  const hasOwnDescription = isNonEmptyString(metaDescription);

  return {
    title: hasOwnTitle ? titleTag : title?.title,
    description: hasOwnDescription ? metaDescription : getExcerptDescription(title?.excerpt),
    hasOwnMetadata: hasOwnTitle && hasOwnDescription,
  };
};
